import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthModule } from '../security/authorization/auth.module';
import { FormsModule } from '../forms/forms.module';
import { ProfileStatusComponent } from './components/profile-status.component';
import { ProfileStatusService } from './service/profile-status.service';

@NgModule({
    imports: [AuthModule, CommonModule, FormsModule, ReactiveFormsModule, NgbTooltipModule],
    declarations: [ProfileStatusComponent],
    exports: [ProfileStatusComponent],
    providers: [ProfileStatusService],
})
export class ProfileStatusModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/profile-status/profile-status.module.ts